import React, { useEffect, useState } from "react";
import ProfilePhotoPlaceholder from "./ProfilePhotoPlaceholder";

type ProfilePhotoProps = {
  src?: string | null;
  alt?: string;
  className?: string;
  imgClassName?: string;
  /** Force remount / reset error when photo version changes. */
  imgKey?: string | number;
};

/**
 * Renders a profile headshot, falling back to emptyHeadshot when `src` is
 * missing or the image fails to load (CDN/blob 404, etc.).
 */
const ProfilePhoto: React.FC<ProfilePhotoProps> = ({
  src,
  alt = "",
  className = "",
  imgClassName = "h-full w-full object-cover",
  imgKey,
}) => {
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [src, imgKey]);

  if (!src?.trim() || broken) {
    return <ProfilePhotoPlaceholder className={className} />;
  }

  return (
    <img
      key={imgKey}
      src={src}
      alt={alt}
      className={imgClassName}
      onError={() => setBroken(true)}
      draggable={false}
      loading="lazy"
      decoding="async"
    />
  );
};

export default ProfilePhoto;
